export default "__VITE_ASSET__JSaqMR0S__"